import { render } from "./CopyrightPage.vue?vue&type=template&id=318495d7&scoped=true"
import script from "./CopyrightPage.vue?vue&type=script&lang=js"
export * from "./CopyrightPage.vue?vue&type=script&lang=js"

import "./CopyrightPage.vue?vue&type=style&index=0&id=318495d7&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.42_vue@3.5.42_webpack@5.110.3_cssnano@5.1.15_postcss@8.5.28__postcss@8.5.28_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-318495d7"]])

export default __exports__